import React from 'react'
import { TextField } from '@carsys/ui/src/TextField'
import { StandardTextFieldProps } from '@mui/material/TextField'
import { Field, WrappedFieldProps } from 'redux-form'
import { useRegisterTab } from '../Tabs/TabItem'
import { MaterialFieldProps } from './MaterialField'
import { useFieldError } from './hooks/useHelperText'

export type ReduxInputProps = MaterialFieldProps<StandardTextFieldProps>
interface InnerProps extends StandardTextFieldProps, WrappedFieldProps {}

export const RenderTextField = (props: InnerProps) => {
  const { label, placeholder, input, meta, fullWidth, ...custom } = props
  const { isError, errorText } = useFieldError(props.meta)
  const id = custom.id ?? custom.name ?? input.name

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      error={isError}
      helperText={errorText}
      fullWidth={fullWidth}
      {...input}
      {...custom}
      id={id}
    />
  )
}

export const ReduxInput: React.FC<ReduxInputProps> = props => {
  useRegisterTab(props.name)
  // we really need a way to split all reduxFieldProps and materialField props.
  // take care not to pass the onChange directly to the props, it will override the redux field handler
  const { validate, name, placeholder, label, onChange, normalize, required, ...rest } = props

  return (
    <Field
      props={rest}
      validate={props.validate ? props.validate : undefined}
      name={name}
      placeholder={placeholder}
      label={label}
      onChange={onChange}
      component={RenderTextField}
      normalize={normalize}
      variant='outlined'
      InputLabelProps={props.InputLabelProps}
      required={props.required}
      type={props.type}
    />
  )
}

ReduxInput.displayName = 'ReduxInput'

export default React.memo(ReduxInput)
